import React from 'react'
import {
	ApplicationPages,
	setActivePage,
} from './state/features/applicationSlice'
import { useDispatch } from 'react-redux'
import { XIcon } from 'lucide-react'
import { DDGColors } from './constants/colors'
import { DDG_MESSAGE_SOURCE, DdgCloseMessage } from './embed/protocol'

interface mainProps {
	children: any
}

// The popup's launcher button + floating panel chrome now live in the host
// page's loader script (appended to document.body at the top level), which
// is what keeps the popup positioned correctly regardless of the facility
// site's own CSS. This component only renders the in-content close button,
// which tells the loader to hide the panel via postMessage.
const PopupLayout: React.FC<mainProps> = ({ children }) => {
	const dispatch = useDispatch()

	const handleClose = () => {
		dispatch(setActivePage(ApplicationPages.HOME))
		if (typeof window !== 'undefined' && window.self !== window.top) {
			const message: DdgCloseMessage = { source: DDG_MESSAGE_SOURCE, type: 'close' }
			window.parent.postMessage(message, '*')
		}
	}

	return (
		<div className='relative flex flex-col h-full' style={{ overflow: 'hidden' }}>
			<button
				type='button'
				onClick={handleClose}
				className='absolute top-0 left-0 z-40'
			>
				<div className='flex items-center justify-center p-2 bg-lightBlood rounded-br-xl'>
					<XIcon size={14} color={DDGColors.blood} />
				</div>
			</button>
			{children}
		</div>
	)
}

export default PopupLayout
